import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styles from "../../assets/scss/AcceptInvite.module.scss";
import { useAcceptInviteMutation } from "../../slices/admin/admin";

const AcceptInvite = () => {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token");

  const [acceptInvite, { isLoading }] = useAcceptInviteMutation();

  // ✅ Handle Accept click
  const handleAccept = async () => {
    if (!token) {
      toast.error("Invalid or missing token.");
      return;
    }

    try {
      const res = await acceptInvite(token).unwrap();
      toast.success("Invitation accepted successfully!");
      navigate("/login");
    } catch (err) {
      console.error("Accept invite error:", err);
      toast.error(err?.data?.message || "Failed to accept invitation.");
    }
  };

  // ✅ Handle Cancel click
  const handleCancel = () => {
    navigate("/");
  };

  return (
    <div className={styles.acceptInviteContainer}>
      <div className={styles.acceptInviteCard}>
        <h2 className={styles.acceptInviteTitle}>Accept Invitation</h2>
        <p className={styles.acceptInviteSubtitle}>
          You’ve been invited to join our platform. Please confirm your choice below.
        </p>

        <div className={styles.acceptInviteButtonGroup}>
          <button
            className={styles.acceptInviteCancelBtn}
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className={styles.acceptInviteAcceptBtn}
            onClick={handleAccept}
            disabled={isLoading}
          >
            {isLoading ? "Accepting..." : "Accept"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcceptInvite;
